import React, { useState, useEffect } from "react"
import { chatService } from "../services/apichat"
import { API } from "../services/API"

const UserList = ({ onUserSelect, selectedUserId }) => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    fetchAllUsers()
  }, [])

  const fetchAllUsers = async () => {
    try {
      setLoading(true)
      console.log("=== FETCHING ALL USERS FOR ADMIN ===")
      console.log("API endpoint: /api/admin/verified-users")

      // Try to get all users first, fallback to online users if that fails
      try {
        const response = await chatService.getAllUsers()
        console.log("=== ALL USERS API RESPONSE ===")
        console.log("Full response:", response)
        console.log("Response type:", typeof response)
        console.log("Is array:", Array.isArray(response))

        if (response) {
          console.log("Response keys:", Object.keys(response))

          // Handle different possible response structures
          if (response.users && Array.isArray(response.users)) {
            console.log(
              "✅ Found users in response.users:",
              response.users.length
            )
            console.log("Users data:", response.users)
            setUsers(response.users)
          } else if (
            response.verifiedUsers &&
            Array.isArray(response.verifiedUsers)
          ) {
            console.log(
              "✅ Found users in response.verifiedUsers:",
              response.verifiedUsers.length
            )
            console.log("Verified users data:", response.verifiedUsers)
            setUsers(response.verifiedUsers)
          } else if (response.data && Array.isArray(response.data)) {
            console.log(
              "✅ Found users in response.data:",
              response.data.length
            )
            console.log("Data array:", response.data)
            setUsers(response.data)
          } else if (Array.isArray(response)) {
            console.log("✅ Response is direct array:", response.length)
            console.log("Direct array data:", response)
            setUsers(response)
          } else {
            console.log("❌ Unexpected response structure:", response)
            console.log("Response structure details:", {
              hasUsers: !!response.users,
              hasVerifiedUsers: !!response.verifiedUsers,
              hasData: !!response.data,
              isArray: Array.isArray(response),
              type: typeof response,
              keys: Object.keys(response)
            })
            setUsers([])
          }
        } else {
          console.log("❌ Response is null or undefined")
          setUsers([])
        }
      } catch (error) {
        console.log("❌ getAllUsers failed, trying online users...", error)
        try {
          const response = await chatService.getOnlineUsers()
          console.log("Online users response:", response)
          // Handle new API response structure for online users
          if (response.success && response.data && response.data.onlineUsers) {
            console.log(
              "✅ Online users found:",
              response.data.onlineUsers.length
            )
            setUsers(response.data.onlineUsers)
          } else if (response.onlineUsers) {
            // Fallback for old structure
            setUsers(response.onlineUsers)
          } else {
            setUsers([])
          }
        } catch (fallbackError) {
          console.log("❌ Fallback also failed:", fallbackError)
          setUsers([])
        }
      }
    } catch (error) {
      console.error("❌ Error fetching users:", error)
      setError("Failed to load users")
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <span style={{ marginLeft: "10px" }}>Loading users...</span>
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#dc3545" }}>
        <p>{error}</p>
        <button
          onClick={fetchAllUsers}
          className="btn btn-primary"
          style={{ marginTop: "10px", padding: "5px 10px", fontSize: "12px" }}
        >
          Retry
        </button>
        <br />
        <button
          onClick={() => {
            console.log("=== MANUAL API TEST ===")
            fetch(`${API}admin/verified-users`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
              }
            })
              .then(res => res.json())
              .then(data => {
                console.log("Manual API test result:", data)
              })
              .catch(err => {
                console.log("Manual API test error:", err)
              })
          }}
          style={{
            marginTop: "10px",
            padding: "5px 10px",
            fontSize: "12px",
            background: "#28a745",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          Test API Directly
        </button>
      </div>
    )
  }

  return (
    <div style={{ flex: 1, overflow: "auto" }}>
      {/* Debug Info */}
      <div
        style={{
          padding: "10px",
          background: "#f8f9fa",
          borderBottom: "1px solid #dee2e6",
          fontSize: "12px",
          color: "#666"
        }}
      >
        <strong>Debug Info:</strong> Users loaded: {users.length} | API Success:{" "}
        {users.length > 0 ? "✅" : "❌"} |
        <button
          onClick={() => {
            console.log("=== CURRENT STATE DEBUG ===")
            console.log("Users state:", users)
            console.log("Loading state:", loading)
            console.log("Error state:", error)
          }}
          style={{
            marginLeft: "10px",
            padding: "2px 6px",
            fontSize: "10px",
            background: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "3px",
            cursor: "pointer"
          }}
        >
          Log State
        </button>
      </div>

      {users.length === 0 ? (
        <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
          <p>No users found</p>
          <p style={{ fontSize: "12px", marginTop: "10px" }}>
            Check console for API response details
          </p>
          <button
            onClick={fetchAllUsers}
            style={{
              marginTop: "10px",
              padding: "5px 10px",
              fontSize: "12px",
              background: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Reload Users
          </button>
        </div>
      ) : (
        <div>
          {users.map(user => (
            <div
              key={user._id}
              onClick={() => onUserSelect(user._id)}
              style={{
                padding: "15px 20px",
                borderBottom: "1px solid #dee2e6",
                cursor: "pointer",
                background: selectedUserId === user._id ? "#e3f2fd" : "white",
                transition: "background-color 0.2s ease"
              }}
              onMouseEnter={e => {
                if (selectedUserId !== user._id) {
                  e.currentTarget.style.backgroundColor = "#f8f9fa"
                }
              }}
              onMouseLeave={e => {
                if (selectedUserId !== user._id) {
                  e.currentTarget.style.backgroundColor = "white"
                }
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: user.isOnline ? "#28a745" : "#6c757d",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                    marginRight: "12px",
                    fontSize: "16px"
                  }}
                >
                  {user.name.charAt(0).toUpperCase()}
                </div>
                <div style={{ flex: 1 }}>
                  <h4
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      color: "#333",
                      fontWeight: "500"
                    }}
                  >
                    {user.name}
                  </h4>
                  <p
                    style={{
                      margin: "2px 0 0 0",
                      fontSize: "12px",
                      color: "#666"
                    }}
                  >
                    {user.email}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "4px"
                    }}
                  >
                    <div
                      style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        background: user.isOnline ? "#28a745" : "#6c757d",
                        marginRight: "6px"
                      }}
                    ></div>
                    <span
                      style={{
                        fontSize: "11px",
                        color: user.isOnline ? "#28a745" : "#6c757d",
                        fontWeight: "500"
                      }}
                    >
                      {user.isOnline ? "Online" : "Offline"}
                    </span>
                    {user.role && (
                      <span
                        style={{
                          fontSize: "10px",
                          color: "#666",
                          marginLeft: "8px",
                          background: "#f8f9fa",
                          padding: "2px 6px",
                          borderRadius: "10px"
                        }}
                      >
                        {user.role}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default UserList
